function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "40fba",
  d: "M822.12 634.39c0 40.284-45.555 72.94-101.75 72.94s-101.75-32.656-101.75-72.94 45.555-72.94 101.75-72.94 101.75 32.656 101.75 72.94z"
}), React.createElement("path", {
  id: "40fbb",
  d: "M667.792 652.75v12.337c0 15.53 12.71 28.163 28.337 28.163h28.221c15.626 0 28.338-12.633 28.338-28.163V652.75h-84.896zM724.35 700H696.13C676.759 700 661 684.338 661 665.087v-15.712a3.384 3.384 0 0 1 3.396-3.375h91.687a3.384 3.384 0 0 1 3.396 3.375v15.712c0 19.25-15.759 34.913-35.129 34.913z"
}), React.createElement("path", {
  id: "40fbc",
  d: "M756.09 652.745a3.405 3.405 0 0 1-2.868-1.562 3.363 3.363 0 0 1 1.041-4.66l40.27-25.632a3.41 3.41 0 0 1 4.725.853 3.362 3.362 0 0 1-.859 4.697l-3.024 2.08-37.464 23.697a3.415 3.415 0 0 1-1.82.527z"
}), React.createElement("path", {
  id: "40fbd",
  d: "M797.672 619.35l2.76 4.164 15.652-10.247v-.004c.56-.362.942-.923 1.074-1.575a2.466 2.466 0 0 0-.361-1.875 2.473 2.473 0 0 0-1.588-1.068 2.507 2.507 0 0 0-1.887.359zm1.794 12.212a3.397 3.397 0 0 1-2.838-1.52l-6.497-9.798a3.338 3.338 0 0 1-.49-2.535 3.375 3.375 0 0 1 1.458-2.139l18.488-12.102a9.276 9.276 0 0 1 6.991-1.335 9.234 9.234 0 0 1 5.893 3.968 9.148 9.148 0 0 1 1.34 6.948 9.174 9.174 0 0 1-3.993 5.857l-18.488 12.1a3.398 3.398 0 0 1-1.864.556z"
}), React.createElement("path", {
  id: "40fbe",
  d: "M711.933 639.25a3.39 3.39 0 0 1-2.033-.676 3.356 3.356 0 0 1-.68-4.723l5.094-6.75a7.891 7.891 0 0 0 0-9.453c-3.896-5.165-3.896-12.383 0-17.547l5.094-6.75a3.407 3.407 0 0 1 4.752-.676 3.356 3.356 0 0 1 .68 4.723l-5.094 6.75a7.891 7.891 0 0 0 0 9.453c3.897 5.164 3.897 12.382 0 17.547l-5.093 6.75a3.388 3.388 0 0 1-2.72 1.351z"
}), React.createElement("path", {
  id: "40fbf",
  d: "M688.163 639.25a3.39 3.39 0 0 1-2.033-.676 3.356 3.356 0 0 1-.68-4.723l5.094-6.75a7.891 7.891 0 0 0 0-9.453c-3.896-5.165-3.896-12.383 0-17.547l5.094-6.75a3.407 3.407 0 0 1 4.752-.676 3.356 3.356 0 0 1 .68 4.723l-5.094 6.75a7.891 7.891 0 0 0 0 9.453c3.897 5.164 3.897 12.382 0 17.547l-5.093 6.75a3.388 3.388 0 0 1-2.72 1.351z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  opacity: 0.7,
  transform: "rotate(14 2721.067 -2133.742)"
}, React.createElement("use", {
  fill: "#effff6",
  xlinkHref: "#40fba"
})), React.createElement("g", {
  transform: "translate(-613 -569)"
}, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#40fbb"
})), React.createElement("g", {
  transform: "translate(-613 -569)"
}, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#40fbc"
})), React.createElement("g", {
  transform: "translate(-613 -569)"
}, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#40fbd"
})), React.createElement("g", {
  transform: "translate(-613 -569)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#40fbe"
})), React.createElement("g", {
  transform: "translate(-613 -569)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#40fbf"
})));

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 215,
    height: 156,
    viewBox: "0 0 215 156",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.6d32332f.svg";
export { ForwardRef as ReactComponent };